import React from 'react';
import { COUNTRIES } from './Constants';

// Mapping from full country names to 2-letter codes
const COUNTRY_NAME_TO_CODE = {
  'India': 'IN',
  'United States': 'US',
  'United Kingdom': 'GB',
  'China': 'CN',
  'Japan': 'JP',
  'Germany': 'DE',
  'Brazil': 'BR',
  'Indonesia': 'ID',
  'Russia': 'RU',
  'Mexico': 'MX',
  'Vietnam': 'VN',
  'South Korea': 'KR',
  'France': 'FR',
  'Canada': 'CA',
  'Australia': 'AU',
  'Spain': 'ES',
  'Italy': 'IT',
  'Philippines': 'PH',
  'Thailand': 'TH',
  'Saudi Arabia': 'SA',
  'UAE': 'AE',
  'Poland': 'PL',
  'Argentina': 'AR',
  'Egypt': 'EG',
  'Netherlands': 'NL',
  'Sweden': 'SE',
  'Belgium': 'BE',
  'Singapore': 'SG'
};

const CountryFlag = ({ countryCode, size = '2rem', style = {}, className = '' }) => {
  // Convert full country name to 2-letter code if needed
  const normalizedCountryCode = COUNTRY_NAME_TO_CODE[countryCode] || countryCode;
  
  const country = COUNTRIES.find(c => c.value === normalizedCountryCode);
  const flagSrc = country?.flag || './assets/flags/default.png';

  return (
    <img
      src={flagSrc}
      alt={`${country?.label || countryCode} flag`}
      style={{ 
        width: size,
        height: size,
        objectFit: 'contain',
        display: 'block',
        margin: '0',
        padding: '0',
        border: 'none',
        outline: 'none',
        verticalAlign: 'top',
        ...style 
      }}
      className={className}
      onError={(e) => {
        // Prevent infinite loop by checking if we're already showing default
        const currentSrc = e.currentTarget.src;
        const defaultSrc = './assets/flags/default.png';
        
        // Only set default if we're not already showing it
        if (!currentSrc.includes('default.png')) {
          e.currentTarget.src = defaultSrc;
        } else {
          // If default.png also fails, hide the image to stop the loop
          e.currentTarget.style.display = 'none';
        }
      }}
    />
  );
};

export default CountryFlag;


